import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type {
  Match,
  CreateMatchRequest,
  UpdateMatchRequest,
  MatchFilters,
  MatchStatus,
  Pagination,
} from "@/types/api.types";

export const matchesService = {
  getAllMatches: async (
    filters?: MatchFilters,
  ): Promise<{ matches: Match[]; pagination: Pagination }> => {
    const params = new URLSearchParams();
    if (filters?.phase) params.append("phase", filters.phase);
    if (filters?.status) params.append("status", filters.status);
    if (filters?.nationId)
      params.append("nationId", filters.nationId.toString());
    if (filters?.gameweekId)
      params.append("gameweekId", filters.gameweekId.toString());
    if (filters?.search) params.append("search", filters.search);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.limit) params.append("limit", filters.limit.toString());
    if (filters?.sortBy) params.append("sortBy", filters.sortBy);

    return apiClient.get(`${API_ENDPOINTS.MATCHES.LIST}?${params.toString()}`);
  },

  getMatch: async (id: number): Promise<Match> => {
    return apiClient.get(API_ENDPOINTS.MATCHES.DETAIL(id));
  },

  createMatch: async (data: CreateMatchRequest): Promise<Match> => {
    return apiClient.post(API_ENDPOINTS.MATCHES.CREATE, data);
  },

  updateMatch: async (id: number, data: UpdateMatchRequest): Promise<Match> => {
    return apiClient.patch(API_ENDPOINTS.MATCHES.UPDATE(id), data);
  },

  deleteMatch: async (id: number): Promise<{ message: string }> => {
    return apiClient.delete(API_ENDPOINTS.MATCHES.DELETE(id));
  },

  updateStatus: async (id: number, status: MatchStatus): Promise<Match> => {
    return apiClient.patch(API_ENDPOINTS.MATCHES.UPDATE_STATUS(id), { status });
  },

  getLiveMatches: async (): Promise<Match[]> => {
    return apiClient.get(API_ENDPOINTS.MATCHES.LIVE);
  },

  getUpcomingMatches: async (): Promise<Match[]> => {
    return apiClient.get(API_ENDPOINTS.MATCHES.UPCOMING);
  },
};
